import type { Rule } from 'antd/es/form';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { isPasswordValid } from 'common/validators';

export const useNewPasswordRules = () => {
  const { t } = useTranslation();

  return useMemo(
    () => [
      {
        required: true,
        whitespace: true,
      },
      {
        message: '',
        // eslint-disable-next-line @typescript-eslint/require-await -- Antd interface need async validator
        async validator(_: Rule, value: string) {
          if (!isPasswordValid(value)) {
            throw new Error(t('Invalid password'));
          }
        },
      },
    ],
    [t],
  );
};
